module.exports = __webpack_public_path__ + "media/images/dev/large-teaser-960x490-e50e5a2ee398bec707a4914d95cae892.jpg";